import React, { useState, useMemo, useRef } from "react";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj, getAdobeAnalyticsContentObj, getAdobeAnalyticsSocailListObj } from '../../analytics/analyticsObject';
import getCategoryBasedOnContentKeyId from '../../../src/utils/utility'


const ShareModal = ({ post, onClose }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [copyFail, setCopyFail] = useState(false);
  const ref = useRef(null);

  const url = useMemo(() => {
    const baseUrl = `${window.location.protocol}//${window.location.hostname}`;
    const contentKey = post.contentKey.split("/")[0];
    return `${baseUrl}/SharedPosts/Show/${contentKey}/${post.id}`;
  }, [post.contentKey, post.id]);

  const linkedinUrl = useMemo(() => {
    return `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(
      "Share article title"
    )}&summary=${encodeURIComponent("Summary")}&mini=true`;
  }, [url]);

  const twitterUrl = useMemo(() => {
    return `https://twitter.com/share?url=${encodeURIComponent(
      url
    )}&text=${encodeURIComponent(post.subTitle)}`;
  }, [url, post.subTitle]);

  const facebookUrl = useMemo(() => {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`;
  }, [url]);

  const closeModal = () => {
    document.querySelector("body").classList.remove("overflow-hidden");
    onClose();
  };

  useOnClickOutside(ref, () => {
    closeModal();
  });

  const share = (link) => {
    let left = Math.round(window.screen.width / 2 - 640 / 2);
    let top = Math.round(window.screen.height / 2 - 480 / 2);
    const window_config = `width=${640},height=${480},left=${left},top=${top}`;

    window.open(
      link,
      "Share this",
      `${window_config},toolbar=no,menubar=no,scrollbars=no`
    );

    closeModal();
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopySuccess(true);
      })
      .catch(() => {
        setCopyFail(true);
      });
  };
  const adobeCustomLog = (link) => {
    let socialTool = link
    if (link === 'linkedIn') {
      link = linkedinUrl
    }
    else if (link === 'Facebook') {
      link = facebookUrl
    }
    else if (link === 'Twitter') {
      link = twitterUrl
    }
    else if (link === "copyToClipboard") {
      link = url
    }
    let industryArray = (post.industry && post.industry.length > 0) ? (post.industry).map(item => (item.name)) : ''
    let topicsArray = (post.topic && post.topic.length > 0) ? (post.topic).map(item => ',' + item.name) : ''
    let subTopicsArray = (post.subTopic && post.subTopic.length > 0) ? (post.subTopic).map(item => ',' + item.name) : ''
    let tagsArray = industryArray + topicsArray + subTopicsArray;
    tagsArray = tagsArray.replace(',,', ',')
    let contEventObj = getAdobeAnalyticsEventObject(
      "card-cont-click",
      "card-cont-click",
      "cont-social-interaction",

    );

    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'share:' + socialTool,
      "card-footer",
      link
    );
    let socailObj = getAdobeAnalyticsSocailListObj({
      socialTool: socialTool,
    })
    let contObj = getAdobeAnalyticsContentObj({
      contClick: 'share',
      contID: post.contentKey,
      contLang: post.language,
      contName: post.title,
      contType: getCategoryBasedOnContentKeyId(post.contentType),
      contTags: tagsArray,
      contTopic: post.topic[0].name,
      contSource: post.source,
      contIndustry: industryArray && industryArray.length > 0 ? industryArray : 'not available',
    });
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      onContClickData: { ...contEventObj, ...socailObj, ...contObj },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (
    <div
      className="fixed z-50 overflow-auto flex items-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, .4)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
      }}
    >
      <div
        ref={ref}
        className="relative p-8 border-2 border-gray-800 bg-white w-full max-w-md m-auto h-custom"
        style={{
          width: "230px",
        }}
      >
        <div className="text-center">Share to:</div>

        <div className="flex justify-between mt-5">
          <div className="cursor-pointer" onClick={() => {
            share(linkedinUrl)
            adobeCustomLog('linkedIn')
          }}>
            <div className="flex flex-col justify-center items-center">
              <div>
                <img
                  src="/images/linkedin-icon.png"
                  alt="linkedin"
                  style={{ width: "48px" }}
                />
              </div>
              <div>LinkedIn</div>
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => {
            share(facebookUrl)
            adobeCustomLog('Facebook')

          }}>
            <div className="flex flex-col justify-center items-center">
              <div>
                <img
                  src="/images/facebook-icon.png"
                  alt="facebook"
                  style={{ width: "48px" }}
                />
              </div>
              <div>Facebook</div>
            </div>
          </div>
        </div>

        <div className="flex justify-between mt-5">
          <div className="cursor-pointer" onClick={() => {
            share(twitterUrl)
            adobeCustomLog('Twitter')

          }}>
            <div className="flex flex-col justify-center items-center">
              <div>
                <img
                  src="/images/twitter-icon.png"
                  alt="twitter"
                  style={{ width: "48px" }}
                />
              </div>
              <div className="-mt-1">Twitter</div>
            </div>
          </div>
          <div className="cursor-pointer" onClick={() => {
            copyToClipboard()
            adobeCustomLog('copyToClipboard')
          }}
          >
            <div className="flex flex-col justify-center items-center">
              <div>
                <img
                  src="/images/share-link-icon.png"
                  alt="share link"
                  style={{ width: "48px" }}
                />
              </div>
              <div className="-mt-1">Copy Link</div>
            </div>
          </div>
        </div>

        {copySuccess && (
          <div className="text-sm mt-3 px-2 py-2 bg-blue-600 text-white rounded">
            Link has been copied to clipboard
          </div>
        )}
        {copyFail && (
          <div className="text-sm mt-3 px-2 py-2 bg-blue-600 text-white rounded">
            Couldn't copy link to the clipboard. Please copy it manually: {url}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShareModal;
